export default class FantasyPlayersModel {
  public total: number = null;
  public minGoalkeepers: number = null;
  public maxGoalkeepers: number = null;
  public minDefenders: number = null;
  public maxDefenders: number = null;
  public minMidfielders: number = null;
  public maxMidfielders: number = null;
  public minStrikers: number = null;
  public maxStrikers: number = null;
}
